import { AccountInfo, User, Student, Product, Cart, ProductCart, Order } from 'types';
import {
  listenAccountInfo,
  registerUser,
  listenStudentList,
  getStudentData,
  registerStudentData,
  deleteStudentData,
  listenProductCart,
  getAvailableProductList,
  addProductToCart,
  updateAmountProductCart,
  deleteProductCart,
  listenPaymentOrder,
  getDiscountValue,
  listenExistingOrders,
} from './databaseImpl';

export interface IDatabaseService {
  registerUser: (authUser: User, name: string, phone: string) => Promise<User>;
  registerStudentData: (uid: string, studentData: Student, updateStudentKey?: string) => Promise<void>;
  getStudentData: (uid: string, studentCode: string) => Promise<Student | undefined>;
  deleteStudentData: (uid: string, studentId: string) => Promise<void>;
  listenAccountInfo(
    userId: string,
    callback: (accountInfo: AccountInfo) => unknown,
    errorCallback?: (error: Error) => unknown
  ): () => void;
  listenStudentList: (
    uid: string,
    callback: (studentDataList: Array<Student>) => unknown,
    errorCallback?: (error: Error) => unknown
  ) => () => void;
  getAvailableProductList: (schoolCode: string) => Promise<Array<Product>>;
  listenProductCart: (
    uid: string,
    callback: (cart: Cart) => unknown,
    errorCallback?: (error: Error) => unknown
  ) => () => void;
  addProductToCart: (uid: string, productCart: ProductCart, lastUpdateDate: Date) => Promise<void>;
  updateAmountProductCart: (
    uid: string,
    productCode: string,
    studentId: string,
    lastUpdateDate: Date,
    newAmount: number
  ) => Promise<void>;
  deleteProductCart: (uid: string, productCode: string, studentId: string, lastUpdateDate: Date) => Promise<void>;
  listenPaymentOrder: (
    paymentId: string,
    callback: (order: Order | null) => unknown,
    errorCallback?: (error: Error) => unknown
  ) => () => void;
  getDiscountValue: (discountCode: string) => Promise<number>;
  listenExistingOrders: (
    uid: string,
    callback: (orders: Array<Order>) => unknown,
    errorCallback?: (error: Error) => unknown
  ) => () => void;
}

export const databaseService: IDatabaseService = {
  registerUser,
  listenAccountInfo,
  listenStudentList,
  getStudentData,
  registerStudentData,
  deleteStudentData,
  listenProductCart,
  getAvailableProductList,
  addProductToCart,
  updateAmountProductCart,
  deleteProductCart,
  listenPaymentOrder,
  getDiscountValue,
  listenExistingOrders,
};
